import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function Reviews() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'What our clients say',
      trusted: 'Trusted by travellers in Ibiza',
      reviews: [{
        text: 'Driver was waiting at the airport, helped with bags, van was spotless. Will use again.',
        rating: 5,
        name: 'Martin Keller',
        context: 'Airport transfer, July'
      }, {
        text: 'Used them three times — airport, dinner and a day trip. Always on time, easy WhatsApp booking.',
        rating: 5,
        name: 'Rachel Simmons',
        context: 'Multiple trips, August'
      }, {
        text: 'Quick WhatsApp reply, fair price, comfortable vehicle. Simple and reliable.',
        rating: 5,
        name: 'Luca Peretti',
        context: 'Hotel transfer, September'
      }]
    },
    es: {
      title: 'Lo que dicen nuestros clientes',
      trusted: 'La confianza de los viajeros en Ibiza',
      reviews: [{
        text: 'El conductor esperaba en el aeropuerto, ayudó con las maletas y la furgoneta estaba impecable. Repetiremos.',
        rating: 5,
        name: 'Martin Keller',
        context: 'Traslado aeropuerto, julio'
      }, {
        text: 'Los usamos tres veces — aeropuerto, cena y excursión. Siempre puntuales, reserva fácil por WhatsApp.',
        rating: 5,
        name: 'Rachel Simmons',
        context: 'Varios trayectos, agosto'
      }, {
        text: 'Respuesta rápida por WhatsApp, precio justo y vehículo cómodo. Simple y fiable.',
        rating: 5,
        name: 'Luca Peretti',
        context: 'Traslado hotel, septiembre'
      }]
    }
  };
  const {
    title,
    trusted,
    reviews
  } = content[language];
  return <section id="reviews" className="py-10 md:py-16 bg-warm-cream" data-id="element-276">
      <div className="mx-auto max-w-6xl px-5" data-id="element-277">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12 md:mb-16" data-id="element-278">
          <div className="flex items-center justify-center space-x-1 mb-3" data-id="element-279">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-gold-subtle text-gold-subtle" data-id="element-280" />)}
          </div>
          <span className="block text-xs font-semibold tracking-wider text-navy/60 uppercase mb-4" data-id="element-281">
            {trusted}
          </span>
          <h2 className="text-3xl md:text-4xl font-heading text-navy mb-4" data-id="element-282">
            {title}
          </h2>
          <div className="w-12 h-px bg-gold-subtle/40 mx-auto" data-id="element-283" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-284">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-2xl border border-stone/10 shadow-sm flex flex-col" data-id="element-285">
              <div className="flex items-center space-x-0.5 mb-4" data-id="element-286">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < review.rating ? 'fill-gold-subtle text-gold-subtle' : 'fill-stone/20 text-stone/20'}`} data-id="element-287" />)}
              </div>

              <p className="text-slate text-sm leading-relaxed mb-6 flex-1 italic" data-id="element-288">
                "{review.text}"
              </p>

              <div className="flex flex-col" data-id="element-289">
                <span className="text-sm font-semibold text-navy" data-id="element-290">
                  {review.name}
                </span>
                <span className="text-xs text-stone mt-0.5" data-id="element-291">
                  {review.context}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}